import { useAnalytics } from "../hooks/useAnalytics";

/**
 * Analytics Provider Component
 * Wraps the app to automatically handle analytics initialization and page tracking
 * Similar to what AutoCheck.com would use
 */
const AnalyticsProvider = ({ children }) => {
  // The useAnalytics hook handles initialization and page tracking automatically
  useAnalytics();

  // This component just provides the analytics context, no UI
  return children;
};

export default AnalyticsProvider;
